
import $ from 'jquery';

window.addEventListener('turbo:load', function () {
  if (is_create_or_edit_integration_page()) {
    const syncButton = document.getElementById('save-and-sync-button');

    syncButton.addEventListener('click', function () {
      localStorage.setItem('data-redirected-after-sync-start', 'true');
    });
  }
});

function is_create_or_edit_integration_page() {
  return (
    (location.href.split('/').slice(-3)[0] == "integrations" && location.href.split('/').slice(-1) == 'edit') ||
    (location.href.split('/').slice(-2)[0] == "integrations" && location.href.split('/').slice(-1)[0].substring(0, 3) == 'new')
  );
}

export function filter_select_fields() {
  const post_data = { format: "json", connection_setup: $("#integration_form_connection_setup_id").val() };
  $.ajax({
    type: "POST",
    url: "/integrations",
    data: post_data,
    dataType: "json",
    success(response, request) {
      update_components(response);
    }
  });
}

function update_components(response) {
  // Get component options from ajax response
  const parser_classes = response.parser_classes;
  const occupant_components = response.occupant_components;
  const schema_components = response.schema_components;

  // Select fields
  const $parser_select = $("#integration_form_parser_class_name");
  const $occupant_select = $("#integration_form_occupant_component");
  const $schema_select = $("#integration_form_schema_component");

  // Selected values
  const selected_parser = $parser_select.val();
  const selected_occupant = $occupant_select.val();
  const selected_schema = $schema_select.val();

  // Clear select options
  $parser_select.empty();
  $occupant_select.empty();
  $schema_select.empty();

  // Add new select options
  add_options_to_select_field(parser_classes, $parser_select);
  add_options_to_select_field(occupant_components, $occupant_select);
  add_options_to_select_field(schema_components, $schema_select);

  // Reselect previously selected options
  $schema_select.val(selected_schema);
  $occupant_select.val(selected_occupant);
  $parser_select.val(selected_parser);

  // If previously selected options do not exist select first option from list
  if ($parser_select.val() == null) { $parser_select[0].selectedIndex = 0; }
  if ($occupant_select.val() == null) { $occupant_select[0].selectedIndex = 0; }
  if ($schema_select.val() == null) { $schema_select[0].selectedIndex = 0; }
  reveal_hide_csv_schema_field();
}

function add_options_to_select_field(options, $select_field) {
  $.each(options, (key, value) => {
    $select_field.append($("<option></option>").attr("value", value).text(adjust_component_prefix(value)));
  });
}

function adjust_component_prefix(value) {
  let prefix = value.match(/^[A-Z][a-z]*/)[0];

  if (prefix === "Mri") value = "MRI" + value.slice(prefix.length);

  return value;
}

export async function add_unit_on_click(button_id) {
  const button_selector = `#${button_id}`;

  while (!document.querySelector(button_selector)) {
    await new Promise((r) => setTimeout(r, 50));
  }

  const button_element = document.getElementById(button_id);

  // Remove any existing listeners to prevent duplicates
  const new_button = button_element.cloneNode(true);
  button_element.parentNode.replaceChild(new_button, button_element);

  const button_jquery_element = $(button_selector);
  let unit;
  let new_unit;
  let unit_name;
  let split_name;
  let base;
  let incremented_number;
  let new_name;

  document.getElementById(button_id).addEventListener("click", () => {
    unit = button_jquery_element.parent().prev();
    new_unit = unit.clone();

    unit_name = unit.children().last().children().first()
      .attr("name");
    split_name = unit_name.split("unit_");
    base = split_name[0];
    incremented_number = (parseInt(split_name[1].slice(0, -1)) + 1).toString();
    new_name = `${base}unit_${incremented_number}][id]`;

    new_unit.children().last().children().first()
      .attr("name", new_name);

    unit.after(new_unit);
  });
}

function reveal_hide_csv_schema_field() {
  if ($("#integration_form_schema_component").val() == "DefaultCsvSchemaComponent") {
    $("#integration_form_csv_schema_id").show();
    $(`label[for='${$("#integration_form_csv_schema_id ").attr("id")}']`).parent(0).show();
  } else {
    $("#integration_form_csv_schema_id").hide();
    $(`label[for='${$("#integration_form_csv_schema_id ").attr("id")}']`).parent(0).hide();
  }
}
export async function remove_unit_on_click(button_id) {
  const button_selector = `#${button_id}`;

  while (!document.querySelector(button_selector)) {
    await new Promise((r) => setTimeout(r, 50));
  }

  const button_element = document.getElementById(button_id);

  // Remove any existing listeners to prevent duplicates
  const new_button = button_element.cloneNode(true);
  button_element.parentNode.replaceChild(new_button, button_element);

  const button_jquery_element = $(button_selector);
  let unit;
  let new_unit;
  let unit_name;
  let split_name;
  let base;
  let incremented_number;
  let new_name;

  document.getElementById(button_id).addEventListener("click", () => {
    unit = button_jquery_element.parent().prev();
    new_unit = unit.clone();

    unit.remove();
    unit = button_jquery_element.parent().prev();
    unit_name = unit.children().last().children().first()
      .attr("name");
    if (unit_name == undefined) {
      unit.after(new_unit);
      alert("Property has to have at least one unit!");
    }
  });
}
